import styled from '@emotion/styled';

import theme from 'theme';

import {ActionsTop} from '../ActionsTop';
import {ActionsBottom} from '../ActionsBottom';
import {MessageContent} from '../MessageContent';
import {MessageIcon} from '../MessageIcon';

import {SnackbarVariant} from '../types';

import type {SnackbarContentProps, SnackbarMessageInner} from '../types';

const variantShadow: Record<SnackbarVariant, string> = {
  [SnackbarVariant.Default]: 'none',
  [SnackbarVariant.Success]: `-4px 0px 0px 0px ${theme.colors.success}`,
  [SnackbarVariant.Warning]: `-4px 0px 0px 0px ${theme.colors.additional.yellow[50]}`,
  [SnackbarVariant.Error]: `-4px 0px 0px 0px ${theme.colors.additional.red[50]}`,
};

const Container = styled.div<Pick<SnackbarMessageInner, 'variant'>>`
  display: flex;
  align-items: flex-start;
  padding: 8px;
  border-radius: 4px;
  background-color: ${theme.colors.grey[90]};
  box-shadow: ${props => variantShadow[props.variant]};
`;

const Content = styled.div`
  flex-grow: 1;
`;

const Top = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const MessageComponent: React.FC<SnackbarContentProps> = props => {
  const {variant, maxWidth, className, style, qa = 'snackbar-message'} = props.message;

  const resultProps = {...props, qa};

  const containerProps = {
    variant,
    className,

    'data-qa': qa,

    style: {maxWidth, ...style},
  };

  return (
    <Container {...containerProps}>
      <MessageIcon {...resultProps} />

      <Content>
        <Top>
          <MessageContent {...resultProps} />
          <ActionsTop {...resultProps} />
        </Top>

        <ActionsBottom {...resultProps} />
      </Content>
    </Container>
  );
};
